module.exports = __webpack_public_path__ + "img/1_Social_Ecological_Transformation_in_Vietnam _ENG_frontcover.99e6d1d5.jpg";